import TableHead from "../table-head/table-head";
import { Department, RequirementDirection } from "../../types/data";
import DirectionBlock from "../direction-block/direction-block";

type TableFactoryProps = {
  data: RequirementDirection[];
  dataHead: Department[];
}

function TableFactory({ data, dataHead }: TableFactoryProps) {
  return (
    <div
      className="no-outer-borders w-[100%] overflow-x-auto scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] rounded-md shadow overflow-y-auto"
    >
      <table className="w-[100%] table-fixed border-collapse border bg-white">
        <TableHead data={dataHead} isFactory />

        {data.map((element, index) => (
          <DirectionBlock
            key={index}
            departments={dataHead}
            {...element}
          />
        ))}
      </table>
    </div>
  )
}

export default TableFactory;
